import Model, { encoders, ID, IsoDateTime } from 'src/models/model'
import User from 'src/models/user/User'

export default class CashDepositDrop extends Model {
  static name = 'CashDepositDrop'

  static deletable = true

  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.PointOfSale, Model.permissionCategories.HardwareAndRegisterStation]

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      user: {
        type: User,
        output: true
      },
      amount: {
        type: Number,
        encode: encoders.cents,
        default: 0
      },
      note: {
        type: String,
        default: null
      },
      createdAt: {
        type: IsoDateTime,
        output: true
      },
      updatedAt: {
        type: IsoDateTime,
        output: true
      },
      displayUser: {
        type: User,
        local: true,
        computed () {
          if (this.isLocal) {
            return this.context?.currentUser
          } else {
            return this.user
          }
        }
      }
    }
  }
}
